import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { ISupersetApiDependencySegment } from '@cbridge-packages/api-superset';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { parseDatasourceString } from '../_helpers/buildChartDataRequest';
import { SupersetAction } from '../superset.action';
import { SupersetTranslator } from '../superset.translator';

type IDependencies = ISupersetApiDependencySegment;

export const loadChartMetadataEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SupersetAction.loadChartMetadata.started),
  mergeMap((params) => {
    const { sliceId } = params;

    return dependencies.supersetApi.getChartMetadata(sliceId).pipe(
      mergeMap((response) => {
        if (!parseDatasourceString(response.result?.form_data?.datasource)) {
          const error = {
            status: 400,
            errorCode: '',
            description: 'Invalid datasource format in chart metadata',
          };
          return [
            SupersetAction.loadChartMetadata.failed({ params, error }),
            createApiErrorNotification(error),
          ];
        }

        return [
          SupersetAction.loadChartMetadata.done({
            params,
            result: SupersetTranslator.fromApiMetadata(response.result),
          }),
        ];
      }),
      catchApiError((error) => {
        return [
          SupersetAction.loadChartMetadata.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
